<template>
    <div class="w3-margin">
        <div v-if="$store.getters.isLogin">
            <h4 class="page-title">TELJESÍTÉSEIM</h4>         
            <table class="w3-table-all w3-small">
                <tr>
                    <td colspan="3">Sikeres teljesítés: {{stat[0]}} db / Útvonal: {{stat[3]}} db</td>
                    <td class="w3-hide-small w3-center"></td>
                    <td class="w3-center w3-hide-small">{{stat[2] | filterRound}} km</td>
                    <td class="w3-hide-small w3-center">{{stat[1]}}</td>
                    <td class="w3-hide-small w3-center"></td> 
                    <td class="w3-hide-small w3-center"></td> 

                    <td ></td>
                </tr>
                <tr class="theme-1" >
                    <td>#</td>
                    <td class="cursorpointer" v-on:click="sortBy('hikeName')">
                        Név
                        <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                    </td>
                    <td class="cursorpointer w3-center" v-on:click="sortBy('startdate')">
                        Dátum
                        <font-awesome-icon v-if="sortKey=='startdate' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='startdate' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                    </td>
                    <td class="w3-hide-small w3-center">Idő</td>
                    <td class="w3-center w3-hide-small cursorpointer" v-on:click="sortBy('distance')">
                        Táv
                        <font-awesome-icon v-if="sortKey=='distance' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='distance' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                    </td>                     
                    <td class="w3-hide-small w3-center">Pont</td>
                    <td class="w3-hide-small w3-center">Értékelés</td>
                    <td class="w3-hide-small w3-center"></td> 
                    <td></td>
                </tr>

                <tr v-on:click="setCertify(item)" class="cursorpointer" v-for="(item, index) in orderedFavoriteList" :key="index">                
                        <td>{{index+1}}.</td>
                        <td class="">
                            {{item.hikeName}}
                            <span title="A teljesítés feltöltésére még nem került sor" v-if="isCertifyUploadWarning(item)" class="w3-text-yellow" ><font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon></span>                        
                            <span title="Ez a túra nincs letöltve, így offline állapotban nem lesz teljesíthető" v-if="isOfflineWarning(item)" class="w3-text-yellow" ><font-awesome-icon icon="cloud-download-alt"></font-awesome-icon></span>
                        </td>
                        <td class="w3-center">{{item.startdate | filterDateFormat2}}</td>
                        <td class="w3-hide-small w3-center">{{item.sumtime | filterNumberToTime2}}</td>
                        <td class="w3-hide-small w3-center">{{item.distance}} km</td>                        
                        <td class="w3-hide-small w3-center">{{item.ggpoint}}</td>
                        <td class="w3-hide-small w3-center">
                            <span v-if="item.rating==0">-</span>
                            <span v-else>{{item.rating}}</span>
                        </td>

                        <td class="w3-hide-small w3-center">
                            <span v-if="item.status==2" v-on:click.prevent.stop="genDipStart(item)"><font-awesome-icon class="w3-text-red" icon="file-pdf"></font-awesome-icon> Oklevél</span>
                        </td>
                        <td class="w3-right" style="min-width:50px">
                            <span v-if="item.status==0" title="" class=" w3-text-black" ><font-awesome-icon icon="angle-double-right"></font-awesome-icon>&nbsp;</span>
                            <span v-if="item.status==1" title="" class=" w3-text-blue" ><font-awesome-icon icon="history"></font-awesome-icon>&nbsp;</span>
                            <span v-if="item.status==2" title="" class=" w3-text-green" ><font-awesome-icon icon="check-circle"></font-awesome-icon>&nbsp;</span>
                            <span v-if="item.status==3" title="" class=" w3-text-red" ><font-awesome-icon icon="times-circle"></font-awesome-icon>&nbsp;</span>
                            <span v-if="isOnline" v-on:click.stop="deleteDataConfirm(item)" class="cursorpointer w3-text-red w3-right"><font-awesome-icon icon="trash-alt"></font-awesome-icon></span>
                            <span v-if="isOnline && item.status>1" v-on:click.stop="editRating(item)" class="cursorpointer w3-text-blue w3-right"><font-awesome-icon icon="edit"></font-awesome-icon></span>                        
                        </td>               
                </tr>
            </table> 
        </div> 

        <div v-if="isShowRating" class="w3-modal" style="z-index: 4000; display:block;">
            <div class="w3-modal-content w3-card-4 w3-animate-zoom">
                <div class="w3-display-container">
                    <div class="w3-blue">
                        <h3 class="w3-padding">Útvonal értékelése</h3>
                    </div>
                    <div class="w3-padding">
                        <div class="w3-margin-right">
                            <label class="w3-text-blue">Értékelés</label>
                            <select class="w3-select w3-border w3-light-grey" v-model="ratingItem.rating">
                                <option value=1>1</option>
                                <option value=2>2</option>
                                <option value=3>3</option>
                                <option value=4>4</option>
                                <option value=5>5</option>
                            </select>   
                        </div>
                    </div>
                </div>
                <div class="w3-container w3-light-grey w3-padding">
                    <button class="w3-button w3-right w3-green w3-margin-left" v-on:click="saveRating">Mentés</button>
                    <!--<button class="w3-button w3-right w3-green w3-margin-left" v-on:click="isShowRating=false">Bezárás</button>-->
                </div>
            </div> 
        </div> 

    </div>
</template>

<script>
import jsPDF from 'jspdf';
import "../Roboto-Black-normal.js";
import "../filters.js";
const fb = require('../firebase.js');
import {store} from "../store.js";
export default {
    name: 'FavoriteList',
    data() {
        return {
            favoriteList: null,
            sortKey: 'startdate',
            reverse: 'desc',
            isShowRating:false,
            ratingItem:null
        }
    },         
    mounted() {
        if (this.$store.getters.userProfile){
            if (this.isOnline) {
                this.getFavoriteList();
            } else {
                this.favoriteList = this.$storage.get('favoriteList', null);
            }            
        }
    },
    created: function(){
    },
    computed: {   
        stat: function(){
            var out=[];
            var list=this.orderedFavoriteList;
            var count=0;
            var dist=0;
            var gp=0;
            var wayList=[];
            for (var i in list) {
                if (list[i].status==2) {
                    count++;
                    gp+=list[i].ggpoint;
                    dist+=list[i].distance;
                    if (wayList.indexOf(list[i].hikeId) === -1) wayList.push(list[i].hikeId);                                 
                }
            }
            out.push(count);
            out.push(gp);
            out.push(dist);
            out.push(wayList.length);
            return out;            
        },
        orderedFavoriteList: function () {
            var orderedList=_.orderBy(this.favoriteList, [this.sortKey], [this.reverse]);        
            return orderedList;
        },
    },        
    methods:{
        saveRating(){
            this.isShowRating=false;
            if (this.ratingItem.rating!=0) {
                this.$showSpinner(); 
                fb.UpdateCertify(this.ratingItem).then(res=>{  
                    this.$hideSpinner();                               
                }).catch(e=>{
                    console.log(e);
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az értékelés mentése során.'));
                })
            }
        },
        editRating(item){
            this.ratingItem=item;
            this.isShowRating=true;
        },
        genDipStart(item){
            alert('Oklevél generálás indul'); 
            fb.GetDiploma(item.hikeId).then(res=>{
                var avgSpeed=0; 
                if (item.sumtime>0) avgSpeed=item.distance/(item.sumtime/3600);
                var imgData = res;
                var doc = new jsPDF("l", "mm", [420,595]); //72/25.4 [210,148]                
                doc.setFont('Roboto-Black'); 
                var width = doc.internal.pageSize.getWidth();
                var wCenter= (width*11/21)/2;
                var height = doc.internal.pageSize.getHeight();                
                doc.addImage(imgData, 'JPEG', 0, 0, width, height);     
                doc.setTextColor(38,62,74); //r,g,b
                doc.setFontSize(28);                
                if (item.dipName.length>20) doc.setFontSize(20);
                else doc.setFontSize(24);
                doc.text(item.dipName.toUpperCase(), wCenter, 66, 'center');
                doc.setFontSize(20);
                doc.text(item.hikeName.toUpperCase(), wCenter, 88, 'center');                
                doc.setFontSize(11);                
                var st=item.distance + ' km  |  ' + this.$options.filters.filterNumberToTime(item.sumtime) +'  |  '+this.$options.filters.filterFloatRound(avgSpeed)+' km/h';                
                doc.text(st, wCenter, 107, 'center');                
                var kt=this.$options.filters.filterDateFormat(item.enddate);
                doc.text(kt, 85, 142);
                doc.save(item.userName+'.pdf', { returnPromise: true }).then(r=>{
                    alert('Az oklevél elkészült!');
                }).catch(e=>{
                    alert('Hiba történt az oklevél létrehozása során!');
                });
            }).catch(e=>{
                alert('Hiba történt az oklevél sablon letöltése során!');
            });                        
        },
        deleteDataConfirm(item){
            let self = this;
            this.$dialog.confirm(this.$setDialogMsg("w3-yellow","Törlés","Biztosan törlöd ezt a teljesítést ("+item.hikeName+")?"))
            .then(function(dialog) {
                self.$showSpinner();
                fb.UpdateCertify(item,true).then(res=>{  
                    self.$hideSpinner();                               
                    self.getFavoriteList();  
                }).catch(e=>{
                    console.log(e);
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a teljesítés törlése során.'));
                })
            });  
        },           
        sortBy(sortKey) {
            if (this.sortKey == sortKey) {
                if (this.reverse=='asc') this.reverse='desc';
                else this.reverse='asc';
            };
            this.sortKey = sortKey;
        },
        isOfflineWarning(item){
            if (item.status>1) return false;
            else return !(this.$storage.has('ggData2-'+item.hikeId)); 
        }, 
        isCertifyUploadWarning(item){
            return (this.$storage.get('uploadCertifyList', []).indexOf(item.id)>-1); 
        },            
        getFavoriteList(){
                this.$showSpinner();
                fb.GetFavoriteList(this.$store.getters.userProfile.uid).then(res=>{
                    this.favoriteList = res;
                    this.$storage.set('favoriteList', res);                     
                    this.$hideSpinner();
                }).catch(e=>{
                    console.log(e);
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a lista betöltése során.'));
                }); 
        },  
        setCertify(cert){
            if (cert.status>1) {
                if (this.isOnline) {
                    this.$router.push({name:'displaycertify', params: { cert: cert } });                        
                } else {
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Befejezett teljesítés adatlapja csak online állapotban tekinthető meg!'));
                }
            } else {
                if (this.$isRefreshActualCerify(cert)) this.$storage.set('actualCertify',cert); 
                else { //Az adatbázisba valamilyen hiba miatt nem a friss állapot van, ezért frissíteni kell.
                    if (this.isOnline) {
                        fb.UpdateCertify(this.$storage.get('actualCertify',null)).then(res=>{   
                        }).catch(e=>{
                            console.log(e);
                        })                
                    }
                }
                this.$router.push('certify');
            }
        }
    }
}

</script>

